import { Page, Indicator } from "@shapeable/kelp-forest-alliance-types";
import { Classable } from "@shapeable/types";

export type RegionsTabs = 'overview' | 'authors' | 'community' | 'projects' | 'resources';

export type Guidebook = Page & {
};

const isPageType = (entity: Page, type: string) => {
  return entity.type?.slug === type || entity.types?.[0]?.slug === type;
  
};

export const isGuidebookPage = (entity: Page): entity is Guidebook => isPageType(entity, 'guidebook');

export type IndicatorLayoutComponentProps = Classable & {
  entity?: Indicator;
}